
var spices = document.getElementById('article-main__spice-list');
var products = document.getElementById('article-main__product-list');
if(spices){
var spiceContainer = spices.querySelector('#spice-list');
}
if(products){
var productContainer = products.querySelector('#spice-list');
}

var spicesAddToCart = document.getElementById('spice-list__addToCart');


if(spicesAddToCart){
    spicesAddToCart.addEventListener('click', createCartList);
}




function createCartList(){

    var checkboxs = spiceContainer.querySelectorAll('.checkbox:checked');
    var cartList = [];

    console.log(checkboxs);
    
    checkboxs.forEach(function(item){
     
         item = {
                    "id": item.value,
                    'quantity': 1
                }

        cartList.push(item);
    })

    if(cartList.length > 0){
        CartJS.addItems(cartList,{
            "success": function(data, textStatus, jqXHR) {
                window.dispatchEvent(spiceCartOpen);
            }
        });
    } else {
        alert('No spices are selected');
    }

  }





  